import { isNull } from './validations';

export const DEPARTMENT_ID_DDD = 10;

export const OBJECT_REFERRAL_POINT_17_WARNING_MESSAGE =
    'Перед началом работы обязательно проверьте заполнение пункта №17';

export const isDddDepartment = (departmentId) => Number(departmentId) === DEPARTMENT_ID_DDD;

export const isObjectReferralPoint17Filled = (specifications, actId) => {
    if (!specifications?.length) {
        return false;
    }
    if (actId) {
        return true;
    }
    return !specifications.some(
        (_) => isNull(_?.inconsistenceQuantity) || !_?.quantity
    );
};

export const withObjectReferralPoint17Warning = async (
    { departmentId, specifications, actId },
    alert,
    action
) => {
    if (
        isDddDepartment(departmentId) ||
        isObjectReferralPoint17Filled(specifications, actId)
    ) {
        await action();
        return;
    }
    await alert('Внимание!', OBJECT_REFERRAL_POINT_17_WARNING_MESSAGE);
    await action();
};
